import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BLACK, BLUE } from '../../../../styles';

const SloganLangButton = ({ borderColor }:{
  borderColor?: string,
}) => {
  const { i18n } = useTranslation();
  return (
    <>
      <BorderColumn
        borderColor={borderColor}
      />
      <LangButton
        type="link"
        isChosen={true}
        style={{ paddingRight: 4  }}
        onClick={() =>
          i18n.changeLanguage(i18n.language !== 'pl' ? 'pl' : 'en')}
      >
        {i18n.language !== 'pl' ? 'Go back to PL' : 'EN presentation'}
      </LangButton>
    </>
  );
};
export default SloganLangButton;


const BorderColumn = styled.span<{ borderColor?: string }>`
border-right: 1px solid ${props =>
    props.borderColor ?? 'black'};
height: 18px; 
width:1;


@media only screen and (max-width: 350px) {
    display: none;
	}
`;

const LangButton = styled(Button)<{ color?: string, isChosen: boolean }>`
    color: ${BLACK};
    font-weight: 400;
    opacity: ${props =>
    props.isChosen ? '100%' : '20%'};
   :hover{
      color: ${props =>
    props.color ?? BLUE};
   }
`;